exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overdue-font[data-v-7018daf7] {\n    font-size: 12px;\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    color: #666;\n}\n.fa-exclamation-triangle.text-warning[data-v-7018daf7] {\n    background:linear-gradient(#555,#555) center bottom/20% 84% no-repeat;\n    font-size: 1.25em;\n}    \n", ""]);

// exports
